var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 22.7816C8.53553 22.7816 9.375 21.9422 9.375 20.9066C9.375 19.8711 8.53553 19.0316 7.5 19.0316C6.46447 19.0316 5.625 19.8711 5.625 20.9066C5.625 21.9422 6.46447 22.7816 7.5 22.7816Z",
    fill: "#5A5B5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 22.7816C18.2855 22.7816 19.125 21.9422 19.125 20.9066C19.125 19.8711 18.2855 19.0316 17.25 19.0316C16.2145 19.0316 15.375 19.8711 15.375 20.9066C15.375 21.9422 16.2145 22.7816 17.25 22.7816Z",
    fill: "#5A5B5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96562 7.40662H20.7844L18.525 15.3191C18.4353 15.6327 18.2458 15.9085 17.9853 16.1047C17.7248 16.301 17.4074 16.407 17.0812 16.4066H7.66875C7.34259 16.407 7.0252 16.301 6.76468 16.1047C6.50416 15.9085 6.31469 15.6327 6.225 15.3191L3.04688 4.20037C3.00203 4.04357 2.9073 3.90567 2.77704 3.80755C2.64677 3.70943 2.48808 3.65644 2.325 3.65662H1.125",
    stroke: "#5A5B5D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.fa687d1fdd6cb63372d1745f330898dc.svg";
export { ForwardRef as ReactComponent };